import { observer } from 'mobx-react-lite'
import { type ReactElement, useMemo } from 'react'
import { ContactsPageComponent } from 'app/components/contacts-page/ContactsPageComponent'
import { useContactsPage } from 'app/components/contacts-page/useContactsPage'
import { ListKindLine } from 'app/components/lists/ListKindLine'
import { PersonalListMarker } from 'app/components/lists/PersonalListMarker'
import type { List } from 'app/generated/graphql'
import { isPersonalList } from 'lib/listVisibility'

export const ManualListTable = observer(function ManualListTable({
  list,
  viewToggle,
  titleActions,
}: {
  list: List
  viewToggle: ReactElement
  titleActions?: ReactElement
}): ReactElement {
  const listMembers = useMemo(() => ({ list }), [list])
  const props = useContactsPage({ listMembers })
  return (
    <ContactsPageComponent
      {...props}
      viewToggle={viewToggle}
      titleActions={titleActions}
      newContact={false}
      removeFromList={list}
      titleMarker={<PersonalListMarker personal={isPersonalList(list)} />}
      subheader={<ListKindLine kind="manual" />}
    />
  )
})
